import { useLang } from "../i18n";
import { useReveal } from "../hooks/useReveal";

const ARTIST_IMG =
  "https://customer-assets.emergentagent.com/job_1ed3182d-c2e3-4132-9c29-53360c74ba18/artifacts/r0w9bsr6_30bcea32-3803-42b3-98bf-9b81691372f2.jpeg";

export default function About() {
  const { t } = useLang();
  const r1 = useReveal();
  const r2 = useReveal();

  return (
    <section id="artist" data-testid="about-section" className="relative bg-black py-24 md:py-40">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        {/* Image column */}
        <div ref={r1} className="reveal lg:col-span-5 relative">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={ARTIST_IMG}
              alt="Joweney Balentien tattoo work — woman and wolf morph"
              className="w-full h-full object-cover object-center"
              loading="lazy"
            />
            <div className="absolute inset-0 ring-1 ring-white/10" />
          </div>
          {/* Caption / quote */}
          <div className="mt-6 flex items-start gap-3">
            <span className="mt-3 h-[3px] w-14" style={{ background: "hsl(var(--red))" }} />
            <p className="font-editorial italic text-xl md:text-2xl text-white/85 leading-snug max-w-md">
              {t.about.quote}
            </p>
          </div>
        </div>

        {/* Text column */}
        <div ref={r2} className="reveal lg:col-span-7">
          <p className="overline mb-6">{t.about.overline}</p>
          <h2
            data-testid="about-title"
            className="font-display text-4xl sm:text-6xl lg:text-7xl uppercase tracking-tighter leading-[0.95]"
          >
            {t.about.title}
          </h2>
          <p className="mt-6 font-script text-5xl md:text-7xl leading-[0.9] normal-case">
            {t.about.lead}
          </p>

          <div className="mt-8 space-y-5 text-white/75 text-base md:text-lg leading-relaxed max-w-2xl">
            <p>{t.about.p1}</p>
            <p>{t.about.p2}</p>
            <p>{t.about.p3}</p>
          </div>

          {/* Stats */}
          <div className="mt-12 grid grid-cols-3 gap-6 max-w-xl border-t border-white/10 pt-8">
            {t.about.stats.map((s, i) => (
              <div key={i} data-testid={`stat-${i}`}>
                <div className="font-display text-3xl md:text-5xl text-white">{s.k}</div>
                <div className="mt-2 text-[11px] uppercase tracking-[0.22em] text-white/55">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
